
    import '/home/ec2-user/Youlify-Design/components/s3-upload/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["s3-upload-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/s3-upload/index.zh-CN.md?type=demo')
};